export const EXCHANGE_RATE_SHEET_NAME = 'ExchangeRateSheet';
export const EXCHANGE_RATE_ALIAS = 'exchangeRate';
export const EXCHANGE_RATE_REFERENCE = `${EXCHANGE_RATE_SHEET_NAME}.${EXCHANGE_RATE_ALIAS}`;
